import {use} from 'react';

import {ConfirmationDialogCtx} from '../components/ConfirmationDialogCtx';
import {ConfirmationDialogCtxProps} from '../types/ConfirmationDialogCtxProps';

const useConfirmationDialogContext = (): ConfirmationDialogCtxProps => use(ConfirmationDialogCtx);

type UseConfirmationDialog = {
  getConfirmation: () => Promise<void>;
};

export const useConfirmationDialog = (): UseConfirmationDialog => {
  const {openDialog} = useConfirmationDialogContext();

  const getConfirmation = (): Promise<void> =>
    new Promise((resolve, reject) => {
      openDialog({resolve, reject});
    });

  return {getConfirmation};
};
